import { z } from 'zod'

/** An API key as shown in the dashboard. The secret itself is never listed. */
export const apiKeySchema = z.object({
  /** Opaque LiteLLM token, used as the identifier for update and revoke. */
  token: z.string(),
  name: z.string(),
  /** Masked form LiteLLM returns for display, e.g. `sk-...a1b2`. */
  maskedKey: z.string(),
  spendUsd: z.number(),
  maxBudgetUsd: z.number().nullable(),
  createdAt: z.string(),
})

export type ApiKey = z.infer<typeof apiKeySchema>

export const apiKeyListSchema = z.object({ data: z.array(apiKeySchema) })

export type ApiKeyList = z.infer<typeof apiKeyListSchema>

export const createApiKeyRequestSchema = z.object({
  name: z.string().trim().min(1).max(64),
  maxBudgetUsd: z.number().positive().max(100_000).nullable().default(null),
})

export type CreateApiKeyRequest = z.infer<typeof createApiKeyRequestSchema>

/** The plaintext key is returned exactly once, at creation. */
export const createApiKeyResponseSchema = z.object({
  secret: z.string(),
  apiKey: apiKeySchema,
})

export type CreateApiKeyResponse = z.infer<typeof createApiKeyResponseSchema>

export const updateApiKeyRequestSchema = z
  .object({
    name: z.string().trim().min(1).max(64).optional(),
    maxBudgetUsd: z.number().positive().max(100_000).nullable().optional(),
  })
  .refine((value) => Object.keys(value).length > 0, {
    message: 'Provide at least one field to update',
  })

export type UpdateApiKeyRequest = z.infer<typeof updateApiKeyRequestSchema>
